<template>
  <div>
    <!-- Tabela z harmonogrami składowymi -->
    <component-table
      actionsWidth="40%"
      addButtonText="buttons.add-schedule"
      :addButtonPermissions="permission"
      :actions="actions"
      :columns="columns"
      :data="containerSchema.$model"
      :total="containerSchema.$model.length"
      :hideSearchInput="true"
      @add="showAddModal()"
      @edit="showEditModal(getIndex($event))"
      @delete="showDeleteDialog(getIndex($event))"
      @up="orderUp(getIndex($event))"
      @down="orderDown(getIndex($event))"
    />

    <schedule-modal
      :show="showModal"
      :schedule="schedule"
      :id="idToEdit"
      :total="containerSchema.$model.length"
      @save="add"
      @close="hideModal"
      @update="update"
    />
  </div>
</template>

<script>
import ScheduleModal from '../modals/ScheduleModal';
import ComponentTable from '@/components/table/Table';
import SportModal from '@/components/modals/SportModal';
import { listMixin } from '@/mixins/list';
import { UP_ACTION, DOWN_ACTION, EDIT_ACTION, DELETE_ACTION } from '@/utils/constants';

// @vuese
// Lista z harmonogrami składowymi
// @group Schedule
export default {
  name: 'SchedulesForm',
  props: {
    // schema kontenera harmonogranmów
    containerSchema: {
      type: Object,
      required: true
    },
    // Typ encji
    entityType: {
      required: false,
      type: String
    },
    // Rodzaj encji
    entityId: {
      required: false,
      type: String
    },
    // id schedule Container
    scheduleContainerId: {
      type: Number,
      required: false
    }
  },
  mixins: [
    listMixin('schedule', {
      listError: 'messages.schedule.listError',
      getError: 'messages.schedule.getError',
      added: 'messages.schedule.added',
      addError: 'messages.schedule.addError',
      updated: 'messages.schedule.updated',
      updateError: 'messages.schedule.updateError',
      deleteConfirm: 'messages.schedule.deleteConfirm',
      deleted: 'messages.schedule.deleted',
      deleteError: 'messages.schedule.deleteError'
    })
  ],
  data() {
    return {
      schedule: undefined,
      columns: [{ name: 'name', displayName: 'columns.name' }]
    };
  },
  methods: {
    // @vuese
    // Usuwa harmonogram składowy
    remove(index) {
      this.containerSchema.$model.splice(index, 1);
    },
    // @vuese
    // Dodaje harmonogram do schema
    add(model) {
      this.containerSchema.$model.push({ ...model });
      this.schedule = undefined;
      this.hideModal();
    },
    // @vuese
    // Akutalizuje harmonogram ze schemy
    update(model) {
      this.containerSchema.$model[this.idToEdit] = { ...model };
      this.schedule = undefined;
      this.hideModal();
    },
    // @vuese
    // Pokazuje modal z edycją harmonogramu
    showEditModal(index) {
      this.idToEdit = index;
      this.schedule = { ...this.containerSchema.$model[index] };
      this.showAddModal();
    },
    // @vuese
    // Znajduje index harmonogramu z tablicy
    getIndex(schedule) {
      return this.containerSchema.$model.indexOf(schedule);
    },
    // @vuese
    // Zmienia kolejność harmonogramu
    orderUp(index) {
      if (index - 1 >= 0 && this.containerSchema.$model.length) {
        this.containerSchema.$model[index].order--;
        this.containerSchema.$model[index - 1].order++;

        const temp = this.containerSchema.$model[index];
        this.containerSchema.$model.splice(index, 1, { ...this.containerSchema.$model[index - 1] });
        this.containerSchema.$model.splice(index - 1, 1, { ...temp });
      }
    },
    // @vuese
    // Zmienia kolejność harmonogramu
    orderDown(index) {
      if (index + 1 <= this.containerSchema.$model.length - 1 && this.containerSchema.$model.length) {
        this.containerSchema.$model[index].order++;
        this.containerSchema.$model[index + 1].order--;

        const temp = this.containerSchema.$model[index];
        this.containerSchema.$model.splice(index, 1, { ...this.containerSchema.$model[index + 1] });
        this.containerSchema.$model.splice(index + 1, 1, { ...temp });
      }
    }
  },
  computed: {
    permission() {
      if (this.scheduleContainerId) {
        return `SCHEDULES_CONTAINER.UPDATE:schedulesContainer:${this.scheduleContainerId}`;
      }
      return `SCHEDULES_CONTAINER.ADD:${this.entityType}:${this.entityId}`;
    },
    actions() {
      return [
        { ...UP_ACTION, permissions: this.permission },
        { ...DOWN_ACTION, permissions: this.permission },
        { ...EDIT_ACTION, permissions: this.permission },
        { ...DELETE_ACTION, permissions: this.permission }
      ];
    }
  },
  components: {
    ComponentTable,
    ScheduleModal
  }
};
</script>
